export default "__VITE_ASSET__BxhnEiEG__"